export default __webpack_public_path__ + "static/media/my-numbers.3984c774.svg";